(() => {
  class LajeBanner extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.over = false;
      this.addEventListener('pointerenter', () => { this.over = true; });
      this.addEventListener('pointerleave', () => { this.over = false; });
      this.querySelector('[data-banner-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.querySelector('[data-banner-previous]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-banner-pause]')?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); });
      this.updatePause();
      this.timer = setInterval(() => {
        if (!this.paused && !this.over && !document.hidden && !this.contains(document.activeElement)) this.show(this.index + 1);
      }, Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    slides() { return [...this.querySelectorAll('[data-laje-slide]')].filter(x => x.dataset.promoExpired !== 'true'); }
    updatePause() { const button = this.querySelector('[data-banner-pause]'); if (button) { button.textContent = this.paused ? button.dataset.resume : button.dataset.pause; button.setAttribute('aria-pressed', String(this.paused)); } }
    show(index) {
      const slides = this.slides();
      if (!slides.length) return;
      this.index = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      const count = this.querySelector('[data-banner-count]');
      if (count) count.textContent = `${this.index + 1} / ${slides.length}`;
    }
  }
  class LajeShipping extends HTMLElement {
    connectedCallback() {
      this.zip = this.querySelector('[name="zip"]');
      this.province = this.querySelector('[name="province"]');
      this.button = this.querySelector('[data-shipping-calculate]');
      this.result = this.querySelector('.laje-shipping-result');
      this.controller = new AbortController();
      this.button?.addEventListener('click', () => this.calculate());
      this.zip?.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.calculate(); } });
      document.addEventListener('cart:update', () => { this.result.textContent = this.dataset.stale; }, {signal:this.controller.signal});
      if (this.dataset.context === 'cart') {
        const params = new URLSearchParams(location.search);
        if (params.get('laje_cep')) { this.zip.value = params.get('laje_cep'); this.province.value = params.get('laje_uf') || ''; this.calculate(); }
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
    async calculate() {
      if (this.button.disabled) return;
      const zip = this.zip.value.replace(/\D/g, '');
      if (zip.length !== 8 || !this.province.value) { this.result.textContent = this.dataset.invalid; return; }
      this.button.disabled = true;
      this.result.textContent = this.dataset.busy;
      const base = window.Shopify?.routes?.root || '/';
      try {
        const cartResponse = await fetch(`${base}cart.js`);
        if (!cartResponse.ok) throw new Error('cart');
        const cart = await cartResponse.json();
        if (this.dataset.context === 'product') {
          const info = this.closest('.product-details') || document;
          const form = info.querySelector('product-form-component form');
          const variantId = form?.querySelector('[name="id"]')?.value;
          const addButton = form?.querySelector('[type="submit"]');
          if (!variantId || addButton?.disabled) { this.result.textContent = this.dataset.sizeError; return; }
          const alreadyAdded = cart.items.some(item => String(item.variant_id) === String(variantId));
          if (!alreadyAdded) {
            const response = await fetch(`${base}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})});
            if (!response.ok) throw new Error('add');
          }
          this.result.textContent = this.dataset.added;
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('laje_cep', zip); url.searchParams.set('laje_uf', this.province.value); url.hash = 'laje-cart-shipping';
          location.assign(url.href);
          return;
        }
        if (!cart.item_count) { this.result.textContent = this.dataset.empty; return; }
        const params = new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'Brazil','shipping_address[province]':this.province.value});
        const prepared = await fetch(`${base}cart/prepare_shipping_rates.json?${params}`,{method:'POST',signal:this.controller.signal});
        if (!prepared.ok) throw new Error('prepare');
        let data = null;
        for (let attempt = 0; attempt < 10 && data === null; attempt++) {
          if (attempt) await new Promise(resolve => setTimeout(resolve, 1000));
          const response = await fetch(`${base}cart/async_shipping_rates.json?${params}`,{signal:this.controller.signal});
          if (!response.ok) throw new Error('rates');
          data = await response.json();
        }
        if (!data) throw new Error('timeout');
        this.result.replaceChildren();
        if (!data.shipping_rates?.length) { this.result.textContent = this.dataset.none; return; }
        const list = document.createElement('ul');
        for (const rate of data.shipping_rates) {
          const row = document.createElement('li');
          const money = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR',{style:'currency',currency:rate.currency || cart.currency || 'BRL'}).format(Number(rate.price));
          row.textContent = `${rate.presentment_name || rate.name}: ${money}`;
          if (rate.delivery_days?.length) row.textContent += ` • ${[...new Set(rate.delivery_days)].join('–')} ${this.dataset.days}`;
          list.append(row);
        }
        this.result.append(list);
      } catch (error) { if (error.name !== 'AbortError') this.result.textContent = this.dataset.error; }
      finally { this.button.disabled = false; }
    }
  }
  if (!customElements.get('laje-banner')) customElements.define('laje-banner',LajeBanner);
  if (!customElements.get('laje-shipping')) customElements.define('laje-shipping',LajeShipping);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-laje-size-help]');
    if (!button) return;
    const details = button.closest('.product-details');
    const guide = [...(details?.querySelectorAll('details') || [])].find(x => /Guia de Tamanhos|Guia de tamanhos/i.test(x.querySelector('summary')?.textContent || ''));
    const dialog = button.closest('.laje-size-help')?.querySelector('dialog');
    const image = guide?.querySelector('img');
    if (dialog && image) {
      const content = dialog.querySelector('[data-laje-size-content]');
      const copy = image.cloneNode(true);
      copy.removeAttribute('id'); copy.removeAttribute('loading');
      content.replaceChildren(copy);
      dialog.querySelector('[data-laje-size-close]').onclick = () => dialog.close();
      dialog.onclose = () => button.focus({preventScroll:true});
      dialog.showModal();
    } else if (guide) { guide.open = true; guide.querySelector('summary')?.focus(); }
  });
  const expirePromo = () => {
    const end = Date.parse(document.body.dataset.lajePromoEnd);
    if (Number.isFinite(end) && Date.now() >= end) {
      document.querySelectorAll('[data-laje-promo-only]').forEach(x => { x.hidden = true; x.dataset.promoExpired = 'true'; });
      document.querySelectorAll('[data-laje-base-price]').forEach(x => { x.hidden = false; });
      document.querySelectorAll('laje-banner').forEach(x => x.show(0));
    }
  };
  expirePromo(); setInterval(expirePromo,30000);
})();
